import { render } from "./LoggingComponent.vue?vue&type=template&id=0fed5e89&lang=true"
import script from "./LoggingComponent.vue?vue&type=script&lang=js"
export * from "./LoggingComponent.vue?vue&type=script&lang=js"

import "./LoggingComponent.vue?vue&type=style&index=0&id=0fed5e89&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__